import styled from 'styled-components';
import { colors } from 'constants/colors';
import { BasicSectionContainer } from 'screens/style';
import { sectionBackgroundStyles } from 'screens/sectionBackgroundStyles';
import { styleSizes } from 'constants/styleSizes';


export const PrivacyPolicyScreenContainer = styled(BasicSectionContainer)`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  color: ${colors.almostBlack};

  .background {
    ${sectionBackgroundStyles}
  }

  .content {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    column-gap: 20px;
    padding: 64px 0;
    @media only screen and (max-width: ${styleSizes.mobileBreakpoint}) {
        padding: 32px 0;
      }

    .title {
      width: 100%;
      font-size: 48px;
      text-align: center;
      font-weight: bold;
      color: ${colors.almostBlack};
      margin: 0 0 64px 0;
      @media only screen and (max-width: ${styleSizes.tabletBreakpoint}) {
        font-size: 32px;
        font-weight: bold;
        text-align: left;
        margin: 0 0 32px 0;
      }
      @media only screen and (max-width: ${styleSizes.mobileBreakpoint}) {
        line-height: 48px;
        margin: 0 0 24px 0;
      }
    }

    .subtitle {
      width: 100%;
      font-size: 24px;
      text-align: left;
      font-weight: 600;
      color: ${colors.almostBlack};
      margin: 48px 0 0 0;
    }

    .mailTo {
        font-weight: bold;
        color: ${colors.almostBlack};
        text-decoration: none;
    }
    .mailToBut {
        color: ${colors.almostBlack};
        text-decoration: none;

    }
    .secondarySubtitle {
      width: 100%;
      font-size: 20px;
      text-align: left;
      font-weight: 600;
      color: ${colors.almostBlack};
      margin: 32px 0 0 0;
      @media only screen and (max-width: ${styleSizes.tabletBreakpoint}) {
        font-size:18px;
      }
    }

    p {
      width: 100%;
      font-size: 16px;
      text-align: left;
      font-weight: 400;
      color: ${colors.almostBlack};
      margin: 16px 0 0 0;
      line-height: 24px;
    }

    p.ending {
      width: 100%;
      font-size: 16px;
      text-align: left;
      font-weight: 400;
      color: ${colors.almostBlack};
      margin: 48px 0 0 0;
    }

    ul {
      margin: 0;
      padding-inline-start: 48px;
      @media only screen and (max-width: ${styleSizes.mobileBreakpoint}) {
        padding-inline-start: 20px;
      }

      li {
        width: 100%;
        font-size: 16px;
        text-align: left;
        font-weight: 400;
        color: ${colors.almostBlack};
        list-style-type: circle;
        margin: 16px 0 0 0;
        padding-right: 16px;

        .highLight {
          font-weight: bold;
        }
      }
    }
  }

  /* @media only screen and (min-width: 767px) and (max-width: 1200px) {

    .title {
      font-size: 30px;
    }

    .subtitle {
      font-size: 18px;
    }
  }

  @media only screen and (max-width: 767px) {

    .title {
      font-size: 24px;
    }

    .subtitle {
      font-size: 16px;
    }

    .description {
      font-size: 14px;
    }
  } */
`;